// CostChart.js
import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid,
} from 'recharts';

const VENDOR_COLORS = {
  'Palo Alto': '#8884d8',
  'Cisco': '#82ca9d',
  'Aruba': '#ffc658',
  'Juniper': '#ff7300',
};

const CHART_COLORS = {
  'Total Cost': 'rgba(230, 244, 255, 0.7)',
  'Small Sites': 'rgba(255, 240, 230, 0.7)',
  'Medium Sites': 'rgba(230, 255, 236, 0.7)',
  'Large Sites': 'rgba(255, 230, 250, 0.7)',
  'DC Sites': 'rgba(240, 255, 230, 0.7)',
};

export const CostChart = ({ data, selectedVendors, title }) => {
  const chartData = selectedVendors.map((vendor) => ({
    name: vendor,
    value: data[vendor],
  }));

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  return (
    <Box sx={{ height: 200, mt: 2 }}>
      <Typography variant="subtitle1" gutterBottom>
        {title}
      </Typography>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={chartData}
          style={{
            backgroundColor:
              CHART_COLORS[title.split(' Cost')[0]] ||
              CHART_COLORS['Total Cost'],
          }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.1)" />
          <XAxis dataKey="name" padding={{ left: 30, right: 30 }} />
          <YAxis
            tickFormatter={(value) => `$${(value / 1000000).toFixed(1)}M`}
          />
          <Tooltip
            formatter={(value) => formatCurrency(value)}
            labelFormatter={(label) => label}
            contentStyle={{
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              border: '1px solid #ccc',
            }}
          />
          <Legend />
          <Line
            type="monotone"
            dataKey="value"
            stroke="#666"
            strokeWidth={2}
            dot={{
              r: 8,
              fill: (data) => VENDOR_COLORS[data.name],
              strokeWidth: 2,
              stroke: (data) => VENDOR_COLORS[data.name],
            }}
            activeDot={{
              r: 10,
              fill: (data) => VENDOR_COLORS[data.name],
              strokeWidth: 3,
              stroke: (data) => VENDOR_COLORS[data.name],
            }}
            name="Cost"
          />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
};